import { Badge } from "@mantine/core";
import type { PolicyStatus } from "../../apis/tenantFeePolicy";

const COLOR: Record<PolicyStatus, string> = {
  DRAFT: "gray",
  SCHEDULED: "cyan",
  ACTIVE: "green",
  SUSPENDED: "orange",
  ARCHIVED: "gray"
};
const LABEL: Record<PolicyStatus, string> = {
  DRAFT: "Ноорог",
  SCHEDULED: "Хүлээгдэж буй",
  ACTIVE: "Идэвхтэй",
  SUSPENDED: "Түр зогссон",
  ARCHIVED: "Архивласан"
};

export function FeePolicyStatusBadge({ status }: { status: PolicyStatus }) {
  return <Badge color={COLOR[status]} variant="light">{LABEL[status]}</Badge>;
}
